import { PTGC_SET_CATEGORIES_ACTIONS } from './../../constants';

const setCategoriesActions = categories => ({
    type: PTGC_SET_CATEGORIES_ACTIONS,
    categories,
});

export default setCategoriesActions;
